import { render, staticRenderFns } from "./tab-bar-inline.mpx?vue&type=template&id=2f79ced1&isComponent&outputPath=components%2Ftab-bar-inline4e927e22%2Findex"
import script from "./tab-bar-inline.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Ftab-bar-inline4e927e22%2Findex"
export * from "./tab-bar-inline.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Ftab-bar-inline4e927e22%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports